export const formatRentalReservationNumber = (id: number): string => `RES-${String(id).padStart(5, '0')}`;

export const formatRentalReservationReviewPeriod = (businessDays: number): string => {
  return businessDays === 0 ? 'Same day' : `${businessDays} business days`;
};
